// ── 매출 관리 권한 조회 훅 ── useRevenue.js 가 339줄이라 떼어냈다(2026-11-05, 300줄 규칙, 동작 변화 없음)
import { useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { isAdminUser } from '../adminlayout/sidebarFilters';

/** @param {{ codeUp: string, setTab: Function }} p — codeUp: 대문자 회사코드(파인그룹은 빈 문자열) */
export function useRevenuePermissions({ codeUp, setTab }) {
  const [canUseSalesManagement,     setCanUseSalesManagement]     = useState(false);
  const [canUseSalesCardManagement, setCanUseSalesCardManagement] = useState(false);
  const [permReady, setPermReady] = useState(false); // 열쇠를 다 읽었나 — 읽기 전엔 자료를 부르지 않는다

  // ── 권한 조회 ─────────────────────────────────────────────────────────────
  // 파인그룹: SALES_MANAGEMENT / SALES_CARD_MANAGEMENT
  // DOT/외부사: 그 회사 코드만(2026-11-05 사용자 규칙 "회사 자료는 그 회사 열쇠로만") — 예전엔 PINE 열쇠로도 탭이 열렸다. 운영자는 전부.
  useEffect(() => {
    (async () => {
      const r = await apiClient.get('/api/my/permissions');
      const codes   = r.data?.permCodes || [];
      const codeSet = new Set(Array.isArray(codes) ? codes : []);
      const admin = isAdminUser();
      const companyOpen = codeUp
        && (codeSet.has(`REVENUE_${codeUp}_MANAGEMENT`) || codeSet.has(`SETTLEMENT_${codeUp}_MANAGEMENT`));
      const hasSales = admin || (codeUp ? Boolean(companyOpen) : codeSet.has('SALES_MANAGEMENT'));
      const hasCard  = admin || (codeUp ? Boolean(companyOpen) : codeSet.has('SALES_CARD_MANAGEMENT'));
      setCanUseSalesManagement(hasSales);
      setCanUseSalesCardManagement(hasCard);
      // 카드 전용 권한만 있으면 카드승인 탭으로 이동
      if (!hasSales && hasCard) setTab('cards');
      setPermReady(true);
    })();
  }, [codeUp]);

  return { canUseSalesManagement, canUseSalesCardManagement, permReady };
}
